/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2151
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
exports.DragAreaChangeEvent = undefined
var r = require(/* 93 */"tslib")
var i = require(/* 134 */"inversify")
var o = require(/* 195 */"../../../123/195/index")
var a = function (e) {
  function t(t) {
    var n = e.call(this, t.block) || this
    n.type = o.BlockEventType.DRAG_AREA_CHANGE
    n._record_undo = false
    n.block = t.block
    n.area = t.area
    n.is_in = t.is_in
    return n
  }
  (0, r.__extends)(t, e)
  return t = (0, r.__decorate)([(0, i.injectable)()], t)
}(require(/* 647 */"./647").BlockEvent)
exports.DragAreaChangeEvent = a
